import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { DepthIcon } from '@icons/DepthIcon';
import { SubscriptionIcon } from '@icons/index';
import { withLogin } from '@hoc/withLogin';
import { Lnb } from '../../common/lnb';

// MZP2-6364: 1780a74 시점 레거시 Subscription. KTDS 환경(VITE_KTDS_ENABLE_NEW_UI=false)에서만 사용.
export const SubscriptionLegacy: React.FC = withLogin(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Container>
      <Lnb
        menuItem={[
          {
            name: t('Subscription.menu.title'),
            icon: <SubscriptionIcon width={20} height={20} color={theme.colors['ic-gray-main']} />,
            subMenu: [
              {
                name: t('Subscription.menu.list'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'list',
              },
              {
                name: t('Subscription.menu.user'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'user-mgmt',
              },
              {
                name: t('Subscription.menu.connection'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'connections',
              },
              {
                name: t('Subscription.menu.accessRequest'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'usage-registers',
              },
              {
                name: t('Subscription.menu.technicalSupport'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'technical-support',
              },
            ],
          },
        ]}
      />
      <Outlet />
    </Container>
  );
});

const Container = styled('div')`
  width: 100%;
  height: 100%;
  min-height: 100%;
  display: flex;
`;
